// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"fcf01145","508":"49f66a6a","736":"25100284","776":"925567a5"}[chunkId] + ".chunk.js";
};